import styled from "@emotion/styled";

export const Container = styled.div({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
});

export const SpotifyFrame = styled.div({
  width: "80%",
});
